import ACTIONS from '@/store/storeActions';

const actions = {
  [ACTIONS.SET_USER]: (context, payload) => {
    context.commit(ACTIONS.SET_USER, payload)
  },
  [ACTIONS.SET_TIMETABLE]: (context, payload) => {
    context.commit(ACTIONS.SET_TIMETABLE, payload)
  },
  [ACTIONS.UPDATE_TIMETABLE]: (context, payload) => {
    context.commit(ACTIONS.UPDATE_TIMETABLE, payload)
  },
  [ACTIONS.SET_USER_LOADINGSTATE]: (context, payload) => {
    context.commit(ACTIONS.SET_USER_LOADINGSTATE, payload)
  },
}

export default actions;
